import { render } from "./AddonProduct.vue?vue&type=template&id=734139b3&scoped=true"
import script from "./AddonProduct.vue?vue&type=script&lang=js"
export * from "./AddonProduct.vue?vue&type=script&lang=js"

import "./AddonProduct.vue?vue&type=style&index=0&id=734139b3&scoped=true&lang=css"

import exportComponent from "/tmp/build_1a3e5399/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-734139b3"]])

export default __exports__